import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlightTruncate'
})
export class HighlightTruncatePipe implements PipeTransform {
    transform(text: string, query: string, maxLength: number = 100): string {
        if (!text || !query) return this.truncateText(text, maxLength);

        const regex = new RegExp(`(${query})`, 'gi');
        const matchIndex = text.toLowerCase().indexOf(query.toLowerCase());

        if (matchIndex === -1) {
            return this.truncateText(text, maxLength); // No match found
        }

        // Ensure that the highlighted text is always visible
        const beforeText = text.substring(0, matchIndex);
        const highlightedText = text.substring(matchIndex, matchIndex + query.length);
        const afterText = text.substring(matchIndex + query.length);

        // Truncate logic: Always keep highlighted text, truncate before/after
        const truncatedBefore = beforeText.length > maxLength / 2 ? '...' + beforeText.slice(-maxLength / 2) : beforeText;
        const truncatedAfter = afterText.length > maxLength / 2 ? afterText.slice(0, maxLength / 2) + '...' : afterText;

        return `${truncatedBefore}<span class="highlight">${highlightedText}</span>${truncatedAfter}`;
    }

    private truncateText(text: string, maxLength: number): string {
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    }
}